import React from 'react';
import { Button, Card } from 'antd';
import styled from 'styled-components';

const StyledCard = styled(Card)`
  border: 1px solid #aaa;
  border-radius: 2px;
  
  .ant-card-body {
    padding: 16px 8px;
  }
`;


const ResetButton = styled(Button)`
  position: absolute;
  top: -15px;
  right: 10px;
  border-radius: 8px;
  background: white;
  border: 1px solid #bbb;
  padding: 4px 12px;
  
  &:hover {
    background: #f0f0f0;
    border-color: #000;
  }
`;

interface DataActionBoxProps {
  onReset: () => void
  children: React.ReactNode
}
export const DataActionBox: React.FC<DataActionBoxProps> = (props) => {
  const {onReset, children} = props

  const handleReset = () => {
    onReset()
  };

  return (
    <StyledCard
      bordered={false}
      style={{ position: 'relative' }}
    >
      <ResetButton onClick={handleReset}>
        Reset
      </ResetButton>
      <div>{children}</div>
    </StyledCard>
  );
};

